// extracted by mini-css-extract-plugin
export var dropdownIcon = "_p9-6";
export var imgContainer = "_p9-3";
export var menuIcon = "_p9-5";
export var pillWrapper = "_p9-2";
export var pillsContainer = "_p9-1";
export var subscriptionCard = "_p9-0";
export var subscriptionLogo = "_p9-4";